/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetLocationBaseResponse
 */
export interface GetLocationBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetLocationBaseResponse
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBaseResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBaseResponse
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationBaseResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetLocationBaseResponse interface.
 */
export function instanceOfGetLocationBaseResponse(value: object): value is GetLocationBaseResponse {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetLocationBaseResponseFromJSON(json: any): GetLocationBaseResponse {
    return GetLocationBaseResponseFromJSONTyped(json, false);
}

export function GetLocationBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'name': json['name'],
        'description': json['description'],
        'isActive': json['isActive'],
    };
}

export function GetLocationBaseResponseToJSON(json: any): GetLocationBaseResponse {
    return GetLocationBaseResponseToJSONTyped(json, false);
}

export function GetLocationBaseResponseToJSONTyped(value?: GetLocationBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
    };
}

